// Axis-aligned rectangles in board px, for spawning the air round the view (viewZone.ts).

/** A rectangle in board px. */
export interface Rect { x: number; y: number; w: number; h: number }

export const area = (r: Rect): number => Math.max(0, r.w) * Math.max(0, r.h);
export const meet = (a: Rect, b: Rect): Rect => {
  const x = Math.max(a.x, b.x), y = Math.max(a.y, b.y);
  return { x, y, w: Math.max(0, Math.min(a.x + a.w, b.x + b.w) - x), h: Math.max(0, Math.min(a.y + a.h, b.y + b.h) - y) };
};
export const holds = (outer: Rect, inner: Rect): boolean => area(inner) === 0 || (inner.x >= outer.x && inner.y >= outer.y && inner.x + inner.w <= outer.x + outer.w && inner.y + inner.h <= outer.y + outer.h);
export const inRect = (r: Rect, x: number, y: number): boolean => x >= r.x && y >= r.y && x < r.x + r.w && y < r.y + r.h;

/** `a` less `b`, as up to four rectangles. */
export function subtract(a: Rect, b: Rect): Rect[] {
  const m = meet(a, b);
  if (area(m) === 0) return area(a) > 0 ? [a] : [];
  const out: Rect[] = [
    { x: a.x, y: a.y, w: a.w, h: m.y - a.y },                                   // above
    { x: a.x, y: m.y + m.h, w: a.w, h: a.y + a.h - (m.y + m.h) },               // below
    { x: a.x, y: m.y, w: m.x - a.x, h: m.h },                                   // left
    { x: m.x + m.w, y: m.y, w: a.x + a.w - (m.x + m.w), h: m.h },               // right
  ];
  return out.filter((r) => area(r) > 0);
}
